import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuardService } from '@core/guards/auth.guard';
import { MortgagesCrudBuilderConfig } from '@core/pages/crud/mortgages-crud-builder-config';
import { LifeInsuranceStep } from '@core/pages/wizard/configs/life-insurance-step-config';
import { MortgageStep } from '@core/pages/wizard/configs/mortgage-step-config';
import { HomesCrudBuilderConfig } from './pages/crud/homes-crud-builder-config';
import { PeopleCrudBuilderConfig } from './pages/crud/people-crud-builder-config';
import { RentalHomesCrudBuilderConfig } from './pages/crud/rental-homes-crud-builder-config';
import { RetirementsCrudBuilderConfig } from './pages/crud/retirements-crud-builder-config';
import { VehiclesCrudBuilderConfig } from './pages/crud/vehicles-crud-builder-config';
import { WorksCrudBuilderConfig } from './pages/crud/works-crud-builder-config';

const routes: Routes = [
  {
    path: 'register',
    loadChildren: () => import('./pages/register/register.module').then( m => m.RegisterPageModule)
  },
  {path: '', redirectTo: 'login', pathMatch: 'full'},
  {path: 'login', loadChildren: () => import('./pages/login/login.module').then(m => m.LoginPageModule)},
  {
    path: 'dashboard',

    children   : [
      {
        path      : '',
        redirectTo: 'overview',
        pathMatch : 'full',
      },
      {
        path        : 'files',
        loadChildren: () => import('./pages/files/files.module').then(m => m.FilesPageModule)
      },
      {
        path        : 'account',
        loadChildren: () => import('./pages/account/account.module').then(m => m.AccountPageModule)
      },
      {
        path        : PeopleCrudBuilderConfig.path,
        loadChildren: () => import('./pages/breadpages/breadpages.module').then(m => m.BreadpagesPageModule),
        data        : {
          config: PeopleCrudBuilderConfig
        },
      },
      /* {
        path        : PeopleCrudBuilderConfig.path,
        loadChildren: () => import('./pages/breadpages/breadpages.module').then(m => m.BreadpagesPageModule),
        data        : {
          config: PeopleCrudBuilderConfig
        },
      }, */
      {
        path        : VehiclesCrudBuilderConfig.path,
        loadChildren: () => import('./pages/breadpages/breadpages.module').then(m => m.BreadpagesPageModule),
        data        : {
          config: VehiclesCrudBuilderConfig
        },
      },
      {
        path        : MortgagesCrudBuilderConfig.path,
        loadChildren: () => import('./pages/breadpages/breadpages.module').then(m => m.BreadpagesPageModule),
        data        : {
          config: MortgageStep
        },
      },
      {
        path        : LifeInsuranceStep.path,
        loadChildren: () => import('./pages/breadpages/breadpages.module').then(m => m.BreadpagesPageModule),
        data        : {
          config: LifeInsuranceStep
        },
      },
      {
        path        : RentalHomesCrudBuilderConfig.path,
        loadChildren: () => import('./pages/breadpages/breadpages.module').then(m => m.BreadpagesPageModule),
        data        : {
          config: RentalHomesCrudBuilderConfig
        },
      },
      {
        path        : WorksCrudBuilderConfig.path,
        loadChildren: () => import('./pages/breadpages/breadpages.module').then(m => m.BreadpagesPageModule),
        data        : {
          config: WorksCrudBuilderConfig
        },
      },
      {
        path        : HomesCrudBuilderConfig.path,
        loadChildren: () => import('./pages/breadpages/breadpages.module').then(m => m.BreadpagesPageModule),
        data        : {
          config: HomesCrudBuilderConfig
        },
      },
      {
        path        : RetirementsCrudBuilderConfig.path,
        loadChildren: () => import('./pages/breadpages/breadpages.module').then(m => m.BreadpagesPageModule),
        data        : {
          config: RetirementsCrudBuilderConfig
        },
      },
      {
        path        : 'overview',
        loadChildren: () => import('./pages/overview/overview.module').then(m => m.OverviewPageModule)
      },
      {
        path        : 'insurances',
        loadChildren: () => import('./pages/insurances-verzerkeringen/insurances-verzerkeringen.module')
          .then(m => m.InsurancesVerzerkeringenPageModule)
      },
      {
        path        : 'insurances-read',
        loadChildren: () => import('./pages/insurances-verzerkeringen-read/insurances-verzerkeringen-read.module')
          .then(m => m.InsurancesVerzerkeringenReadPageModule)
      },
      {
        path        : 'hypotheek',
        loadChildren: () => import('./pages/hypotheek/hypotheek.module').then(m => m.HypotheekPageModule)
      },
      {
        path        : 'bezittingen',
        loadChildren: () => import('./pages/bezittingen/bezittingen.module').then(m => m.BezittingenPageModule)
      },
      {
        path        : 'verzekeringen-edit',
        loadChildren: () => import('./pages/verzekeringen-edit/verzekeringen-edit.module').then(m => m.VerzekeringenEditPageModule)
      },
      {
        path        : 'wizard',
        loadChildren: () => import('./pages/wizard/wizard.module').then(m => m.WizardPageModule)
      },
      {
        path        : 'viawizard',
        loadChildren: () => import('./pages/viawizard/viawizard.module').then(m => m.VIAWizardPageModule)
      },
      {
        path        : 'improvement-detail',
        loadChildren: () => import('./improvement-detail/improvement-detail.module').then(m => m.ImprovementDetailPageModule)
      },
      {
        path        : 'goals',
        loadChildren: () => import('./pages/goals/goals.module').then(m => m.GoalsPageModule)
      },
      {
        path        : 'fixed-charges',
        loadChildren: () => import('./pages/fixed-charges/fixed-charges.module').then(m => m.FixedChargesPageModule)
      },
      {
        path: 'contact',
        loadChildren: () => import('./pages/contact/contact.module').then( m => m.ContactPageModule)
      },
      {
        path: 'feedback',
        loadChildren: () => import('./pages/feedback/feedback.module').then( m => m.FeedbackPageModule)
      },
      {
        path: 'besparenwiz2',
        loadChildren: () => import('./pages/besparenwiz1/besparenwiz1.module').then( m => m.Besparenwiz1PageModule)
      },
      {
        path: 'besparenwiz3',
        loadChildren: () => import('./pages/besparenwiz2/besparenwiz2.module').then( m => m.Besparenwiz2PageModule)
      },
      {
        path: 'besparenwiz4',
        loadChildren: () => import('./pages/besparenwiz3/besparenwiz3.module').then( m => m.Besparenwiz3PageModule)
      },
      {
        path: 'besparenwiz1',
        loadChildren: () => import('./pages/besparenwiz4/besparenwiz4.module').then( m => m.Besparenwiz4PageModule)
      },
      {
        path: 'besparenwizcomplete',
        loadChildren: () => import('./pages/besparenwizcomplete/besparenwizcomplete.module').then( m => m.BesparenwizcompletePageModule)
      },
      {
        path: 'projects',
        loadChildren: () => import('./pages/timpaan/timpaan.module').then( m => m.TimpaanPageModule)
      },
    ],
    canActivate: [AuthGuardService]
  },
  {path: '**', redirectTo: 'login'},
  {
    path: 'besparenwiz4',
    loadChildren: () => import('./pages/besparenwiz4/besparenwiz4.module').then( m => m.Besparenwiz4PageModule)
  },
  {
    path: 'not-verified',
    loadChildren: () => import('./pages/not-verified/not-verified.module').then( m => m.NotVerifiedPageModule)
  },





  
  
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {preloadingStrategy: PreloadAllModules})
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
